module.exports = __webpack_public_path__ + "static/media/section_2_2_A.7584a471.png";